import FetchAPI from '../FetchAPI'
import CoinsAPI from './coin/CoinsAPI'
import type ICoinsAPI from './coin/ICoinsAPI'
import GlobalAPI from './global/GlobalAPI'
import type IGlobalAPI from './global/IGlobalAPI'

class CoinPriceCacheBackendAPI {
  coin: ICoinsAPI
  global: IGlobalAPI

  constructor() {
    const fetcher = new FetchAPI(import.meta.env.VITE_WEPIN_CACHE_SERVER_URL)
    this.coin = new CoinsAPI(fetcher)
    this.global = new GlobalAPI(fetcher)
  }
  private static instance: CoinPriceCacheBackendAPI

  public static getInstance(): CoinPriceCacheBackendAPI {
    if (!CoinPriceCacheBackendAPI.instance) {
      CoinPriceCacheBackendAPI.instance = new CoinPriceCacheBackendAPI()
    }
    return CoinPriceCacheBackendAPI.instance
  }
}

export default CoinPriceCacheBackendAPI
